/*
 * @Author: 张锐
 * @Date: 2021-04-27 17:26:34
 * @LastEditTime: 2021-06-13 21:59:12
 * @Description: 通用工具
 */
import {
    Message
} from 'element-ui'
import {
    saveAs
} from 'file-saver';
// 时间戳转年月日
export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
}

function padLeftZero(str) {
    return ('00' + str).substr(str.length)
};

export function getfilesize(size) {
    // if (!size) { return '' }
    if (!size) {
        return '-'
    }

    // byte
    var num = 1024.00
    if (size < num) {
        return size + 'B'
    }
    if (size < Math.pow(num, 2)) {
        return (size / num).toFixed(2) + 'K'
    } // kb
    if (size < Math.pow(num, 3)) {
        return (size / Math.pow(num, 2)).toFixed(2) + 'M'
    } // M
    if (size < Math.pow(num, 4)) {
        return (size / Math.pow(num, 3)).toFixed(2) + 'G'
    } // G
    return (size / Math.pow(num, 4)).toFixed(2) + 'T' // T
}

export function getParam(name) {
    const href = decodeURIComponent(location.href)
    return (
        decodeURIComponent(
            (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
                href
                // eslint-disable-next-line no-sparse-arrays
            ) || [, ''])[1].replace(/\+/g, '%20')
        )
    )
}

export function getSubStr(str) {
    const subStr1 = str.substr(0, 9)
    const subStr2 = str.substr(str.length - 2, 5)
    const subStr = subStr1 + '...' + subStr2
    return subStr
}

//复制
export function copyText(text) {
    try {
        let oInput = document.createElement("input");
        oInput.value = text;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        Message({
            message: "复制成功",
            type: "success"
        });
        if (sessionStorage.getItem("browserType") != "IE") {
            oInput.remove();
        }
    } catch (err) {
        Message({
            message: "复制失败,请重试！",
            type: "error"
        });
    }
}
/**
 *导出txt
 * @param {*} res 响应流
 */
export const exportBlobData = res => {
    const blob = new Blob([res.data]);
    const fileName = res.headers.filename;
    if (sessionStorage.getItem("browserType") == 'IE') {
        saveAs(blob, fileName);
    } else {
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = decodeURIComponent(fileName);
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放blob对象
    }
};
export function stringToByte(str) {
  var ch, st, re = []; 
  for (var i = 0; i < str.length; i++ ) { 
      ch = str.charCodeAt(i);  // get char  
      st = [];                 // set up "stack"  

     do {  
          st.push( ch & 0xFF );  // push byte to stack  
          ch = ch >> 8;          // shift value down by 1 byte  
      }    

      while ( ch );  
      re = re.concat( st.reverse() ); 
  }  
  return re;  
} 
export function ByteToString(arr) {
    if (typeof arr === 'string') {
        return arr;
    }
    var str = []
    for (var i = 0; i < arr.length; i++) {
        let one = arr[i].toString(16)
        if(one.length==1){
          one=`0${one}`
        }
        str.push(one)
    }
    return str.join('');
}

export function arrayToTree(arr, parent) {
    var tree = [];
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].parentId === parent) {
        var node = arr[i];
        node.children = arrayToTree(arr, arr[i].id)
        tree.push(node);
      }
    }
    return tree;
}



// WEBPACK FOOTER //
// ./src/comm/utils/tools.js